/**
 * 验证规则
 */

// 必填项
export const requiredRule = {
  required: true,
  message: '这是必填项',
  type: 'string',
};

export const requiredRuleV2 = {
  required: true,
  message: '这是必填项',
};

export function getRuleArray() {
  return [{
    validator: (rule, value, callback) => {
      if (value && value.length > 0) {
        return callback();
      } else {
        return callback('这是必填项');
      }
    },
  }];
}

export function stringWithoutNumberRule() {
  return [
    {
      validator: (_, value, callback) => {
        if (/\d/.test(value)) {
          return callback('请填写正确国别');
        } else {
          return callback();
        }
      },
    },
  ];
}

export function getRuleLen(len, required = false) {
  return [
    {
      validator: (rule, value, callback) => {
        if (required && !value) {
          return callback('这是必填项');
        }
        // if ((/[0-9]/.test(value))) {
        //   return callback('仅支持中文、英文以及标点符号');
        // }
        if (!required && !value) {
          return callback();
        }
        if (typeof value === 'string' && value.length > len) {
          return callback(`请输入${len}个字符以内`);
        }
        return callback();
      },
    },
  ];
}
export function getRuleNumber(required = false, max) {
  return [
    {
      validator: (rule, value, callback) => {
        if (required && Number.isNaN(Number(value))) {
          return callback('这是必填项');
        }
        if (!required && !Number.isNaN(Number(value))) {
          return callback();
        }
        if (typeof value === 'string' && Number(value) >= max) {
          return callback(`请输入${max}以内的数字`);
        }
        return callback();
      },
    },
  ];
}

// 身份证
export const cardRule = {
  required: true,
  type: 'string',
  pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
  message: '请输入正确的身份证号码',
};

// 护照
export const passportRule = {
  required: true,
  type: 'string',
  pattern:
    /^1[45][0-9]{7}|([P|p|S|s]\d{7})|([S|s|G|g]\d{8})|([Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8})|([H|h|M|m]\d{8，10})$/,
  message: '请输入正确的护照号码',
};

// 手机号码
export const phoneRule = {
  required: true,
  type: 'string',
  // 支持港澳台电话号码
  // pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
  //需要校验是否为11位数字
  pattern: /^\d{11}$/,
  message: '请输入正确的手机号码',
};

export const phoneRuleWithoutRequired = {
  type: 'string',
  pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
  message: '请输入正确的手机号码',
};

// 邮箱地址
export const emailRule = {
  required: true,
  type: 'email',
  pattern: /^[.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  message: '请输入正确的邮箱地址',
};
